"use client";
import { TESTIMONIALS } from "~/lib/testimonials";
import TestimonialCard from "./TestimonialCard";

import Box from "@mui/material/Box";

export default function TestimonialsStack() {
  return (
    <>
      {/* Desktop: overlapping stacked layout */}
      <Box
        sx={{
          display: { xs: "none", md: "flex" },
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-start",
          position: "relative",
          overflowX: "auto",
          // Enough padding so rotated cards don't get clipped
          pt: 3,
          pb: 5,
          // Cards overlap: negative margin pulls them together
          gap: 0,
          "& > *": {
            marginLeft: "-40px",
            flex: "0 0 360px",
            maxWidth: 360,
          },
          "& > *:first-of-type": {
            marginLeft: 0,
          },
        }}
      >
        {TESTIMONIALS.map((testimonial, i) => (
          <TestimonialCard
            key={i}
            testimonial={testimonial}
            cardIndex={i}
            totalCards={TESTIMONIALS.length}
          />
        ))}
      </Box>

      {/* Mobile: horizontal scroll  */}
      <Box
        className="hide-scrollbar"
        sx={{
          overflowX: "auto",
          display: { xs: "flex", md: "none" },
          flexDirection: "row",
          gap: 2,
          alignItems: "flex-start",
          // Hide native scrollbars while keeping overflow visible so
          // card transforms (hover/focus) aren't clipped.
          // More bottom padding so upward transforms aren't visually clipped
          pb: 3,
          pt: 3,
          "& > *": {
            flex: "0 0 85%",
            marginLeft: 0,
          },
          ml: -2,
          pl: 4,
          width: "calc(100% + 32px)", // Account for negative margin and padding
        }}
      >
        {TESTIMONIALS.map((testimonial, i) => (
          <TestimonialCard
            key={i}
            testimonial={testimonial}
            cardIndex={i}
            totalCards={TESTIMONIALS.length}
          />
        ))}
      </Box>
    </>
  );
}
